import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c84ecdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "",
  id: "TransactionsView"
}
const _hoisted_2 = { class: "mt-2 mb-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "text-black h6" }, "Your Transactions", -1))
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = {
  key: 0,
  class: ""
}
const _hoisted_6 = { class: "table w-100" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-black" }, "Amount"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-black" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-black" }, "Download")
  ])
], -1))
const _hoisted_8 = { class: "" }
const _hoisted_9 = {
  key: 0,
  class: "text-black"
}
const _hoisted_10 = { class: "text-black" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 1,
  class: "text-center"
}
const _hoisted_13 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_ctx.transactions.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("table", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions.filter(t => t.invoice_id ), (transaction) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: transaction.id,
                      class: ""
                    }, [
                      _createElementVNode("td", _hoisted_8, [
                        (transaction.payments[0]?.amount)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "$" + _toDisplayString(transaction.payments[0]?.amount / 100), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_10, _toDisplayString(transaction.billing_period?.starts_at), 1),
                      _createElementVNode("td", {
                        class: "text-primary cursor-pointer",
                        onClick: ($event: any) => (_ctx.openPdf(transaction.id))
                      }, "Downlaod", 8, _hoisted_11)
                    ]))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.transactions.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("button", {
                class: "btn btn-primary mt-2 mb-4",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadTransactions && _ctx.loadTransactions(...args))),
                disabled: _ctx.loading
              }, _toDisplayString(_ctx.loading ? 'Loading Transactions....' : 'Load Transactions'), 9, _hoisted_13)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}